module.exports = __webpack_public_path__ + "static/global-phone-60cb94f87ec037412be5cd492b48fceb.png";